<template>
    <div class="w3-container flow-card blue-top w3-large text-color">
        <h3 class="flow-blue-color w3-margin font-weight-bold">{{ $t('accountDetails') }}</h3>

        <div class="w3-border w3-col"></div>

        <div class="w3-col">
            <p class="w3-col w3-margin">
                <label class="w3-col w-30pc flow-blue-color">{{ $t('firstName') }}</label>
                <span class="w3-col w-60pc">{{ user.firstName }}</span>
            </p>

            <div class="w3-border w3-border-light-gray w3-col w3-center"></div>

            <p class="w3-col w3-margin">
                <label class="w3-col w-30pc flow-blue-color">{{ $t('lastName') }}</label>
                <span class="w3-col w-60pc">{{ user.lastName }}</span>
            </p>

            <div class="w3-border w3-border-light-gray w3-col w3-center"></div>

            <p class="w3-col w3-margin">
                <label class="w3-col w-30pc flow-blue-color">{{ $t('role') }}</label>
                <span class="w3-col w-60pc">
                    <user-role :role="user.role"></user-role>
                </span>
            </p>

            <div class="w3-border w3-border-light-gray w3-col w3-center"></div>

            <p v-if="user.physicians" class="w3-col w3-margin">
                <label class="w3-col w-30pc flow-blue-color">{{ $t('physician') }}</label>
                <span class="w3-col w-60pc w3-padding">
                  <span v-for="physician in user.physicians" class="w3-col zero-left w3-padding w3-margin w3-show-inline-block">
                      <span class="w3-tag w3-round-medium w3-light-blue">{{ physician.status }}</span>
                      <physician-entry class="zero-left" :physician="physician"></physician-entry>
                    </span>
                    <span v-if="user.agendaSystemPhysician" class="font-weight-bold w3-col">
                        You are the physician
                    </span>
                </span>
            </p>

            <div class="w3-border w3-border-light-gray w3-col w3-center"></div>

            <p class="w3-col w3-margin">
                <label class="w3-col w-30pc flow-blue-color">{{ $t('language') }}</label>
                <span class="w3-col w-60pc">{{ user.language }}</span>
            </p>

            <div class="w3-border w3-border-light-gray w3-col w3-center"></div>

            <p class="w3-col w3-margin">
                <label class="w3-col w-30pc flow-blue-color">{{ $t('email') }}</label>
                <span class="w3-col w-60pc">{{ user.email }}</span>
            </p>
        </div>
    </div>
</template>

<script>
    import UserRole from "../common/UserRole";
    import PhysicianEntry from "./PhysicianEntry";
    export default {
        name: "AccountDetails",
        components: {PhysicianEntry, UserRole},
        props: ["overview"],
        computed: {
            user() {
                return this.overview ? this.overview.user : {};
            }
        }
    }
</script>

<style scoped>

</style>